/**
 * Redirect URL'lerini güvenli şekilde doğrular
 * @param {string} url - Doğrulanacak URL
 * @returns {boolean} - URL güvenli ise true
 */
const isValidRedirectUrl = (url) => {
  if (!url || typeof url !== "string") return false;

  try {
    const urlObj = new URL(url);

    // Sadece HTTP ve HTTPS protokollerine izin ver
    if (!["http:", "https:"].includes(urlObj.protocol)) {
      return false;
    }

    // Güvenli domain whitelist - sadece belirtilen domain'ler
    const allowedDomains = ["nextline.me", "nextlineapp.com"];

    // Domain whitelist kontrolü - sadece exact match
    const isAllowedDomain = allowedDomains.some((domain) => {
      return urlObj.hostname === domain;
    });

    return isAllowedDomain;
  } catch (e) {
    // Geçersiz URL formatı
    return false;
  }
};

export const get_redirect_urls = () => {
  let params = new URL(document.location.toString()).searchParams;
  let success_redirect_url = params.get("success_redirect_url");
  let failed_redirect_url = params.get("failed_redirect_url");

  // URL'den gelen redirect URL'lerini doğrula
  if (success_redirect_url && !isValidRedirectUrl(success_redirect_url)) {
    console.warn(
      "Invalid success_redirect_url, ignoring:",
      success_redirect_url
    );
    success_redirect_url = null;
  }

  if (failed_redirect_url && !isValidRedirectUrl(failed_redirect_url)) {
    console.warn("Invalid failed_redirect_url, ignoring:", failed_redirect_url);
    failed_redirect_url = null;
  }

  // Fallback: URL'de yoksa sessionStorage'dan al
  if (!(success_redirect_url || failed_redirect_url)) {
    try {
      const saved = sessionStorage.getItem("stripe_redirect_params");
      if (saved) {
        const p = JSON.parse(saved);
        const savedSuccess = p.success_redirect_url;
        const savedFailed = p.failed_redirect_url;

        // SessionStorage'dan gelen URL'leri de doğrula
        if (savedSuccess && isValidRedirectUrl(savedSuccess)) {
          success_redirect_url = savedSuccess;
        }
        if (savedFailed && isValidRedirectUrl(savedFailed)) {
          failed_redirect_url = savedFailed;
        }
      }
    } catch (e) {
      // ignore
    }
  }

  return [success_redirect_url, failed_redirect_url];
};

export const get_redirect_url_map = () => {
  const [success_redirect_url, failed_redirect_url] = get_redirect_urls();

  return { success_redirect_url, failed_redirect_url };
};
